import React, { useEffect, useState } from 'react';
import { ApiConnectionString } from '../../../constants/ApiConntection';
import axios from 'axios';
import { useAuthContext } from '../../../hooks/useAuthContext';

export default function ViewPolicy({ cancelModal, clubId }) {
  const [content, setContent] = useState('');
  const [created, setCreated] = useState('');
  const [updated, setUpdated] = useState('');
  const [message, setMessage] = useState('');
  const [loading, setLoading] = useState(true);
  const [policyAgreement, setPolicyAgreement] = useState(null);
  const [complete, setComplete] = useState(false);

  const { user } = useAuthContext();

  const agreeToTerms = async () => {
    setLoading(true);
    try {
      const res = await axios.post(
        `${ApiConnectionString}/api/PolicyAgreement`,
        { clubId },
        {
          headers: { Authorization: `Bearer ${user.token}` },
        }
      );

      if (res.status === 200) {
        await fetchPolicy();
        setComplete(true);
      } else {
        setMessage('Could not record your agreement.');
      }
    } catch (err) {
      setMessage('An error occurred while agreeing to the policy.');
    } finally {
      setLoading(false);
    }
  };

  const fetchPolicy = async () => {
    try {
      if (user) {
        const policyResponse = await axios.get(
          `${ApiConnectionString}/api/PolicyAgreement/${user.id}/${clubId}`,
          {
            headers: { Authorization: `Bearer ${user.token}` },
          }
        );

        if (policyResponse.status === 200) {
          setPolicyAgreement(policyResponse.data);
        }
      }

      const res = await axios.get(
        `${ApiConnectionString}/api/clubPolicy/${clubId}`,
        {
          headers: { Authorization: `Bearer ${user.token}` },
        }
      );

      if (res.status === 200) {
        setContent(res.data.policyContent || '');
        setCreated(res.data.policyCreated || null);
        setUpdated(res.data.policyUpdated || null);
      }
    } catch (err) {
      setMessage('Failed to load policy.');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchPolicy();
  }, []);

  return (
    <div className="send-modal-overlay d-flex justify-content-center align-items-center text-center">
      <div className="send-modal bg-white rounded p-3 position-relative">
        <div className="blueBanner">
          <p className="fw-bold m-2 p-2 fontSize20">Club Policy</p>
        </div>

        <button
          type="button"
          className="close-button"
          onClick={cancelModal}
          aria-label="Close"
        >
          &times;
        </button>

        {loading ? (
          <p>Loading...</p>
        ) : (
          <>
            {message && <p className="text-danger">{message}</p>}

            <p className="fw-bold mt-3">Policy Content:</p>
            <p>{content}</p>

            {created && (
              <>
                <p className="fw-bold mt-3 mb-0">Created:</p>
                <p>{new Date(created).toLocaleString()}</p>
              </>
            )}

            {updated && (
              <>
                <p className="fw-bold mt-3 mb-0">Last Updated:</p>
                <p>{new Date(updated).toLocaleString()}</p>
              </>
            )}

            {user && updated && (!policyAgreement || updated > policyAgreement.policyUpdated) && !complete && (
              <p
                className="oc-red-button p-1 fw-bold pointer"
                onClick={agreeToTerms}
              >
                Agree to Terms
              </p>
            )}

            {complete && <p className="text-success fw-bold mt-3">Thank you for agreeing to the policy.</p>}
          </>
        )}

        <div className="send-modal-footer"></div>
      </div>
    </div>
  );
}
